var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('md-action-sheet',{staticClass:"common-action-sheet",attrs:{"title":_vm.title,"cancel-text":_vm.cancelText,"actions":_vm.list,"active":_vm.active},on:{"choose":_vm.handlerToChoose,"cancel":_vm.handlerToCancel},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }